import React from 'react';
import PropTypes from 'prop-types';
import {
  FullWidthImage,
  FullWidthCard,
  RenderHTML,
  SingleSelectWithRedux as SingleSelect,
  MultiSelectWithRedux as MultiSelect,
  SliderSelectWithRedux as SliderSelect,
  StepSelectWithRedux as StepSelect,
  SliderSelectGroupWithRedux as SliderSelectGroup,
} from '@learningblocks/storybook-components';
import {
  COMPONENT_TYPE,
  VISIBILITY,
} from '@learningblocks/exp-constants/lib/Utilities';
import {HiddenComponent} from '../../../HiddenComponent';

const COLOR_CLASSNAME = 'question_color';

/**
 * ContentItems: Render Components to be displayed
 * in contentes section.
 */
export function ContentItems(props) {
  const renderHTMLComponent = (component, key) =>
    React.createElement(RenderHTML, {key, content: component.text});

  const renderFullWidthImage = (component, key) =>
    React.createElement(FullWidthImage, {key, ...component});

  const renderFullWidthCard = (component, key) =>
    React.createElement(FullWidthCard, {key, ...component});

  const renderSingleSelectQuestion = (component, key) =>
    React.createElement(SingleSelect, {key, ...component});

  const renderMultiSelectQuestion = (component, key) =>
    React.createElement(MultiSelect, {key, ...component});

  const renderSliderSelect = (component, key) =>
    React.createElement(SliderSelect, {key, ...component});

  const renderSliderSelectGroup = (component, key) =>
    React.createElement(SliderSelectGroup, {key, ...component});

  const renderStepSelect = (component, key) => {
    const options = component.options.map((option) => {
      return {value: option.id, label: option.text};
    });
    return React.createElement(StepSelect, {key, ...component, options});
  };

  const composeWithHidden = (component, key, child) =>
    React.createElement(
      HiddenComponent,
      {
        key,
        visibility: component.visibility,
      },
      child(component, key)
    );

  const renderComponent = (component, key) => {
    switch (component.type) {
      case COMPONENT_TYPE.SUB_HEADING:
      case COMPONENT_TYPE.PLAIN_TEXT:
        return renderHTMLComponent(component, key);
      case COMPONENT_TYPE.FULL_WIDTH_IMAGE:
        return renderFullWidthImage(component, key);
      case COMPONENT_TYPE.FULL_WIDTH_CARD:
        return renderFullWidthCard(component, key);
      case COMPONENT_TYPE.CSCQ:
        return renderSingleSelectQuestion(component, key);
      case COMPONENT_TYPE.MSCQ:
        return renderMultiSelectQuestion(component, key);
      case COMPONENT_TYPE.DNDQ_COLOR:
        return composeWithHidden(component, key, renderSliderSelect);
      case COMPONENT_TYPE.DDQ:
        return renderStepSelect(component, key);
      case COMPONENT_TYPE.GROUPED_DNDQ:
        return composeWithHidden(component, key, renderSliderSelectGroup);
      case COMPONENT_TYPE.CSCQ_COLOR:
        return composeWithHidden(
          {
            ...component,
            className: COLOR_CLASSNAME,
          },
          key,
          renderSingleSelectQuestion
        );
      default:
        return null;
    }
  };

  let renderItemsList = [];

  for (let index in props.components) {
    let component = props.components[index];
    renderItemsList.push(renderComponent(component, index));
    if (component && component.finalPoint) {
      break;
    }
  }

  return renderItemsList;
}

ContentItems.propTypes = {
  /**
   * List of component to  be displayed in the section
   */
  components: PropTypes.array.isRequired,
};
